import InputMask from "react-input-mask";
import styled, { css } from "styled-components";
import { getInputPaddingBySize } from "./helpers";
const inputStyles = css `
	background-color: var(--surface-white);
	border: 1px solid var(--border-primary);
	border-radius: 8px;
	color: var(--text-primary);
	font-size: 16px;
	outline: none;
	padding: ${({ size }) => getInputPaddingBySize(size)};
	padding-right: ${({ rightIcon }) => (rightIcon ? "48px" : "16px")};
	padding-left: ${({ leftIcon }) => (leftIcon ? "48px" : "16px")};
	transition: all 300ms ease-in-out;
	width: 100%;
	caret-color: var(--text-primary);

	&::placeholder {
		color: var(--text-disable);
	}

	&:hover {
		border-color: var(--surface-accent-dark); // validar com o Edu se está certo isso.
	}

	&:focus {
		border-color: var(--border-active);
	}

	&:disabled {
		background-color: var(--surface-primary);
		border-color: var(--border-disable) !important;
		color: var(--text-disable);
		cursor: not-allowed;
	}

	${({ feedback }) => !!feedback &&
    css `
			border-color: var(--semantic-${feedback}-base) !important;
		`}

	&[type='search']::-webkit-search-decoration,
	&[type='search']::-webkit-search-cancel-button,
	&[type='search']::-webkit-search-results-button,
	&[type='search']::-webkit-search-results-decoration {
		-webkit-appearance: none;
	}
`;
export const StyledInput = styled.input `
  ${inputStyles}
`;
export const StyledInputMask = styled(InputMask) `
  ${inputStyles}
`;
//# sourceMappingURL=styles.js.map